module.exports = __webpack_public_path__ + "img/spin.cb51eff8.png";